/**
 * 退款单的状态(S-08)。**单点定义在这里,三端引用。**
 *
 * 取值与 prisma 的 RefundStatus、与 apps/api/src/common/enum-parity.ts 的类型级断言
 * 逐字一致 —— 漂移会变成编译错误。
 *
 *   pending     退款单已建,但**还没有成功提交给微信**(微信不可用 / 提交被拒)。
 *               这一档是「等重试」:客户再点一次取消会拿同一个 outRefundNo 重提,
 *               而不是生成第二张退款单(换号重试可能重复退款,抄本 B / AS-001)
 *   processing  微信已受理,等退款结果通知。**中间态不是失败** ——
 *               把 PROCESSING 当成失败去重试,才是真正会重复退款的那种写法
 *   success     退款成功(回调确认)。这一刻冲正结算流水
 *   failed      微信明确说这笔退款失败 / 已关闭。钱还在平台账上,必须有人去处理:
 *               退款提交失败会落一条 refund_request_failed 审计日志(哨兵),
 *               而不是只写一行 warn —— 「有多少单取消了但钱没退」只有那张表答得出来
 *
 * `processing` 与 `failed` 的区别是这个枚举存在的全部理由:
 * 前者要等,后者要人。合成一个的后果是运营分不清该等还是该查。
 */
export const REFUND_STATUS = ['pending', 'processing', 'success', 'failed'] as const

export type RefundStatus = (typeof REFUND_STATUS)[number]

export function isRefundStatus(x: unknown): x is RefundStatus {
  return typeof x === 'string' && (REFUND_STATUS as readonly string[]).includes(x)
}
